import React from "react";
import styled from "styled-components";

export default styled.h2`
  
    text-align: left;
    width: 100%;
    margin: 0;
    margin-bottom: 10px; 
    font-weight: 400;
    color: #5562c0;
    font-size: 16px;
    line-height: 20px;
`;